import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Grid, Typography } from '@material-ui/core';
import Price from '../../../../../../../../gqlCommon/components/presentation/Price';
import priceValueStyles from './PriceValueStyles';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';

export interface IPriceValueProps {
  price: number;
  priceType: PriceDisplayType;
  currency: string;
  boldPrice?: boolean;
  showSign?: boolean;
  loading?: boolean;
  decimals?: number;
  testId?: string;
  taxLabel?: string;
  className?: string;
}

const PriceValue: FunctionComponent<IPriceValueProps> = ({
  price,
  priceType = PriceDisplayType.PRIMARY,
  currency,
  showSign = false,
  boldPrice = true,
  loading,
  decimals,
  testId,
  taxLabel,
  className,
}) => {
  const styles = priceValueStyles();

  return (
    <Grid
      item={true}
      sm={4}
      xs={6}
      className={clsx(styles.priceContainer, [{ [className]: className }])}
      data-test={`summary:price:${testId}`}
    >
      {!loading && showSign && (
        <Typography
          variant="caption"
          className={clsx(styles.price, [
            { [styles.boldPrice]: !className && boldPrice, [styles.thinPrice]: className || !boldPrice },
          ])}
        >
          -
        </Typography>
      )}
      <Price
        priceDisplayType={priceType}
        loading={loading}
        price={price}
        currency={currency}
        variant="caption"
        className={clsx(styles.price, [
          { [styles.boldPrice]: !className && boldPrice, [styles.thinPrice]: className || !boldPrice },
        ])}
        decimals={decimals}
        taxLabel={taxLabel}
      />
    </Grid>
  );
};

export default PriceValue;
